exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cards[data-v-e467d918]{padding:0.5rem;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap\n}\n.cards .card[data-v-e467d918]{margin:12px\n}\n.cards .button[data-v-e467d918]{margin-bottom:32px\n}\n.cardSlot[data-v-e467d918]{width:256px;height:358px;border:2px dotted #140601;margin:12px;border-radius:8px\n}\n", ""]);

// exports
